import { IconFolderCode } from "@tabler/icons-react";

import { Button } from "@/components/ui/button";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/empty";

interface LeagueRosterEmptyStateProps {
  onAddPlayer?: () => void;
  onImportPlayers?: () => void;
  /** When false, the roster is locked (non-draft league): hide the actions. */
  canManage?: boolean;
}

export function LeagueRosterEmptyState({
  onAddPlayer,
  onImportPlayers,
  canManage = true,
}: LeagueRosterEmptyStateProps = {}) {
  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <IconFolderCode />
        </EmptyMedia>
        <EmptyTitle>No Players</EmptyTitle>
        <EmptyDescription>
          {canManage
            ? "Get started by adding your first player."
            : "This roster is empty. Players can only be added while the league is a draft."}
        </EmptyDescription>
      </EmptyHeader>
      {canManage && (
        <EmptyContent className="flex-row justify-center gap-2">
          <Button className="text-xs rounded-lg" onClick={onAddPlayer}>
            Add Player
          </Button>
          <Button
            variant="outline"
            className="text-xs rounded-lg"
            onClick={onImportPlayers}
          >
            Import Players
          </Button>
        </EmptyContent>
      )}
    </Empty>
  );
}
